import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EditorLayoutComponent } from '../editor-layout/editor-layout/editor-layout.component';

@Component({
  selector: 'app-escritos-editor',
  standalone: true,
  imports: [EditorLayoutComponent],
  template: '<app-editor-layout></app-editor-layout>',
  styleUrls: ['./escritos-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EscritosEditorComponent { }
